export const DEFAULT_CONTENT_CAPITALIZATION = {
  value1: 'Capitalização',
  value1Lowercase: 'capitalização',
  value2: 'Capitalizações',
  value2Lowercase: 'capitalizações',
}
export const DEFAULT_CONTENT_TITLE = {
  value1: 'Título',
  value1Lowercase: 'título',
  value2: 'Títulos',
  value2Lowercase: 'títulos',
}
export const DEFAULT_CONTENT_MY_TITLES = {
  value1: 'Meu título',
  value1Lowercase: 'meu título',
  value2: 'Meus títulos',
  value2Lowercase: 'meus títulos',
}
export interface ContentManagerState {
  contentCapitalization: {
    value1: string
    value1Lowercase: string
    value2: string
    value2Lowercase: string
  }
  contentTitle: {
    value1: string
    value1Lowercase: string
    value2: string
    value2Lowercase: string
  }
  contentMyTitle: {
    value1: string
    value1Lowercase: string
    value2: string
    value2Lowercase: string
  }

  getContentManager: () => void
}

export interface IContentManagerParam {
  name: string
  value1: string
  value2: string
}

export interface IContentManagerResponse {
  params: IContentManagerParam[]
}
